import { Authenticator } from '@aws-amplify/ui-react';
import Header from './components/Header';
import Footer from './components/Footer';

function Login() {
  return <Authenticator components={{ Header, Footer }} />;
}

export default Login;
